import Box from "@mui/material/Box";
import { Container } from "../Container/Container";
import PropTypes from "prop-types";
import Typography from "@mui/material/Typography";
import { isDefined } from "@pheaa/channels-component-library";
import { styled } from "@mui/material/styles";

const Section = props => {
	return <Box component="section" {...props} />;
};

const Card = styled(Box)(({ theme }) => ({
	backgroundColor: theme.palette.common.white,
	border: `1px solid ${theme.palette.neutral.light}`,
	borderRadius: 8,
	boxShadow: theme.shadows[3],
	color: theme.palette.text.primary,
	marginBottom: 20,
	marginTop: 20,
	padding: 24
}));

const OverviewCard = props => {

	const {
		content,
		headingAction,
		headingText,
		paddingX = 3
	} = props;

	return (
		<Container component={Section} style={{ display: "flex", flexDirection: "column", minHeight: 420, paddingBottom: 20 }}>
			<Box
				sx={{
					alignItems: "center",
					borderBottom: "1px solid var(--palette-neutral-main)",
					justifyContent: "space-between",
					display: "flex",
					flex: 0,
					minHeight: 80,
					paddingLeft: 3,
					paddingRight: 2
				}}
			>
				<Typography component="h1" variant="h3">
					{headingText}
				</Typography>
				{
					isDefined(headingAction) && (
						<Box sx={{ marginLeft: 2 }}>
							{headingAction}
						</Box>
					)
				}
			</Box>
			<Box
				sx={{
					display: "flex",
					flex: 1,
					flexDirection: "column",
					paddingLeft: paddingX,
					paddingRight: paddingX
				}}
			>
				{content}
			</Box>
		</Container>
	);
};

OverviewCard.propTypes = {
	content: PropTypes.node.isRequired,
	headingLinkDestination: PropTypes.string,
	headingLinkText: PropTypes.string,
	headingText: PropTypes.string
};

export default Card;
export { OverviewCard };